import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/workspaces')({
  // Component is lazy loaded from workspaces.lazy.tsx
});
